import { cn } from '@core/utils';

import { Rating } from '@/app/donation/_components/Rating';
import { Image } from '@/components/client';
import { openResponsiveDialog } from '@/stores/DrawerStore';

import { ReviewDetailContent } from '../../ReviewDetailContent';

interface ReviewListItemProps {
  reviewId: number;
  productThumbnailUrl: string;
  productName: string;
  rating: number;
  reviewContent: string;
}

export const ReviewListItem = ({
  reviewId,
  productThumbnailUrl,
  productName,
  rating,
  reviewContent,
}: ReviewListItemProps) => {
  const isPhotoReview = !!productThumbnailUrl;

  return (
    <button
      type="button"
      className={cn(
        'flex w-fit items-center gap-16 rounded-large bg-Gray-white p-12',
      )}
      onClick={() => {
        openResponsiveDialog({
          component: ReviewDetailContent,
          modalHeader: isPhotoReview ? '포토후기' : '후기',
          className: {
            modal: 'max-w-[900px]',
          },
          props: {
            reviewId,
          },
          drawerNoPadding: true,
        });
      }}
    >
      {/** 답례품 이미지 */}
      <div className="relative size-104 overflow-hidden rounded-medium">
        <Image
          src={productThumbnailUrl}
          fill
          alt={productName}
          className="object-cover"
          sizes="104px"
        />
      </div>

      <div className={cn('flex w-237 flex-col gap-4')}>
        {/** 별점 */}
        <Rating value={rating} size={16} />
        {/** 답례품명 */}
        <div>
          <p
            className={cn(
              'line-clamp-1 text-start font-600 text-Gray-900 typo-body4',
            )}
          >
            {productName}
          </p>
        </div>

        {/** 후기 */}
        <div className={cn('font-400 text-Gray-600 typo-body4')}>
          <span className="line-clamp-2 w-full text-left">{reviewContent}</span>
        </div>
      </div>
    </button>
  );
};
